import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DataTablesModule } from 'angular-datatables';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { UtilityService } from '../Model/utility/utility.service';
import { CommonService } from '../Model/Common/common.service';
import { Subject } from 'rxjs';
import moment from 'moment';

@Component({
  selector: 'app-exceptional-days',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, RouterModule],
  templateUrl: './exceptional-days.component.html',
  styleUrl: './exceptional-days.component.scss'
})
export class ExceptionalDaysComponent {

  isDisabled: boolean = false;

  dtTrigger: Subject<any> = new Subject<any>();

  Years = [] as any;
  TableData = [] as any;
  public User: any = null;
  constructor(
    private toast: ToastService,
    private utility: UtilityService,
    protected common: CommonService,
  ) {
    // this.common.getPageRights();
    this.SelectDate('RegistrationDate', null, null);
  }

  ngOnInit(): void {
    const currentYear = new Date().getFullYear();
    this.filter.Year = currentYear;
    this.GetSiteHolidayHistory();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  filter = {
    Branch: null,
    Site: null,
    Year: null as any
  }

  HistoryFilterOnYear() {
    this.GetSiteHolidayHistory();
  }

  GetSiteHolidayHistory() {
    // this.isDisabled = true;
    // this.holiday.GetSiteHoliday(this.filter).subscribe({
    //   next: (response) => {
    //     this.SiteHolidayHistoryData = Object.values(response.Table);
    //     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //       dtInstance.destroy();
    //       this.dtTrigger.next(null);
    //     });
    //     this.isDisabled = false;
    //   },
    //   complete: () => {
    //     this.isDisabled = false;
    //   },
    //   error: (error) => {
    //     this.isDisabled = false;
    //   },
    // });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        // console.log(response);
        if (SelectType == 'RegistrationDate') {
          this.Years = [moment(response.Table[0].RegistrationDate.RegistrationDate).year() - 1, moment(response.Table[0].RegistrationDate).year(), moment(response.Table[0].RegistrationDate).year() + 1];
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  excelDownload() {
    if (this.TableData.length > 0) {
      this.common.ExcelDump('Exceptional Days', this.TableData);
    } else {
      this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
    }
  }
}
